/**
 * Note: This module is currently only used on the homepage
 */
export class Youtube {
  constructor() {
    const $youtubeButton = $('.js-youtube-button');

    if ($youtubeButton.length > 0) {
      $youtubeButton.on('click', (e) => this.play(e));
    }
  }

  play(e) {
    const $this = $(e.currentTarget);
    const youtubeID = this.parse($this.attr('data-url'));
    const height = $this.outerHeight();

    $this.html('<iframe width="100%"height="'+height+'" src="https://www.youtube.com/embed/' + youtubeID + '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
  }

  parse(url) {
    if (!url) {
      return null;
    }
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }
}

